import { Reference } from '@apollo/client';
import { gql } from '@/__generated__/index.ts';
import { useSubscription } from '@/apollo/use-subscription.ts';
import { TournamentPostCardFragment } from '@/components/tournament-post-card/tournament-post-card-fragment.ts';

const SubmissionsSubscription = gql(`
subscription OnTournamentSubmissions($tournamentId: ID!) {
  tournamentPostsUpdates(tournamentId: $tournamentId) {
    ...TournamentPostCardFragment
  }
}
`);

export const TournamentSubmissionsSubscription = ({ id }: { id: string }) => {
  useSubscription(SubmissionsSubscription, {
    variables: { tournamentId: id },
    onData({ data, client }) {
      const post = data?.data?.tournamentPostsUpdates;

      if (post) {
        client.cache.modify({
          id: client.cache.identify({
            __typename: 'Tournament',
            id,
          }),
          fields: {
            submissions(existing) {
              const items = existing.items as Array<Reference>;

              const newPostRef = client.cache.writeFragment({
                fragment: TournamentPostCardFragment,
                fragmentName: 'TournamentPostCardFragment',
                data: post,
              });

              if (newPostRef) {
                const idx = items.findIndex(
                  (item: { __ref: string }) => item.__ref === newPostRef.__ref,
                );

                const newItems =
                  idx === -1
                    ? [newPostRef, ...items]
                    : items
                        .slice(0, idx)
                        .concat(newPostRef)
                        .concat(items.slice(idx + 1));

                return {
                  ...existing,
                  items: newItems,
                };
              }

              return existing;
            },
          },
        });
      }
    },
  });

  return null;
};
